import React from "react";
import { Link } from "react-router-dom";
import { Product } from "../types/ProductType";
import ImageWithFallback from "./ImageWithFallback";

type ProductProp = {
  product: Product;
  showPrice?: boolean;
}

export const ProductCard = ({product, showPrice = true}: ProductProp ) => {
  const displayPrice = product.final_price || product.price;

  const formatPrice = (price: number): string => {
    if (!price) return '0';
    return Number(price).toFixed(2).replace(/\.00$/, '').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  };

  return (
    <div className="group relative bg-white rounded-lg shadow-sm hover:shadow-lg transition-all duration-300 overflow-hidden border border-gray-100">
      <div className="aspect-w-1 aspect-h-1 w-full overflow-hidden rounded-t-lg bg-gray-100">
        <Link to={`/product/${product.slug}`} className="block">
          <ImageWithFallback
            src={product.image || product.main_image_url}
            alt={product.name}
            className="h-full w-full object-cover object-center group-hover:scale-110 transition-transform duration-300"
          />
        </Link>
      </div>
      <div className="p-4">
        <div className={showPrice ? "mb-2" : ""}>
          <h3 className="text-sm font-medium text-gray-900 line-clamp-2 min-h-[2.5rem]">
            <Link to={`/product/${product.slug}`} className="hover:text-blue-600 transition-colors duration-200">
              <span aria-hidden="true" className="absolute inset-0"></span>
              {product.name}
            </Link>
          </h3>
        </div>
        {showPrice && (
          <div className="flex items-center justify-between">
            <div className="flex items-baseline gap-2">
              {product.final_price && product.final_price < product.price ? (
                <>
                  <span className="text-lg font-bold text-gray-900">
                    {formatPrice(displayPrice)} đ
                  </span>
                  <span className="text-sm text-gray-500 line-through">
                    {formatPrice(product.price)} đ
                  </span>
                </>
              ) : (
                <span className="text-lg font-bold text-gray-900">
                  {formatPrice(displayPrice)} đ
                </span>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
